
export const composeSortByFn = (...fns) => {
    return (a, b) => {

        let result: number;

        // take the most likely case first
        if (fns.length === 2) {
            result = fns[0](a, b);

            if (result === 0) {
                return fns[1](a, b);
            } else {
                return result;
            }
        }
        // why are you calling compose with only one function?
        if (fns.length === 1) {
            return fns[0](a, b);
        }

        for (const fn of fns) {
            result = fn(a, b);

            if (result !== 0) {
                return result;
            }
        }

        return result;
    };
};



// WEBPACK FOOTER //
// ./src/core/util/compose-sort-by-fn.ts